import React, { useState } from 'react';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import ModalClose from '@mui/joy/ModalClose';
import Typography from '@mui/joy/Typography';
import Textarea from '@mui/joy/Textarea';
import Button from '@mui/joy/Button';
import Box from '@mui/joy/Box';

interface ImagePreviewProps {
  isOpen: boolean;
  imageUrl: string;
  onClose: () => void;
  onConfirm: (caption: string) => void;
  isLoading: boolean;
}

const ImagePreview: React.FC<ImagePreviewProps> = ({
  isOpen,
  imageUrl,
  onClose,
  onConfirm,
  isLoading,
}) => {
  const [caption, setCaption] = useState('');

  const handleConfirm = () => {
    onConfirm(caption);
    setCaption('');
  };

  const handleClose = () => {
    setCaption('');
    onClose();
  };

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <ModalDialog
        sx={{ maxWidth: 440, width: '100%' }}
        aria-labelledby="image-preview-title"
      >
        <ModalClose />
        <Typography id="image-preview-title" level="title-lg" component="h2">
          Enviar imagen
        </Typography>
        <Box
          component="img"
          src={imageUrl}
          alt=""
          sx={{ width: '100%', borderRadius: 'sm', objectFit: 'contain', maxHeight: 280 }}
        />
        <Textarea
          placeholder="Agregar un comentario..."
          value={caption}
          onChange={(e) => setCaption(e.target.value)}
          minRows={2}
        />
        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
          <Button variant="plain" color="neutral" onClick={handleClose} disabled={isLoading}>
            Cancelar
          </Button>
          <Button color="primary" onClick={handleConfirm} loading={isLoading}>
            Enviar
          </Button>
        </Box>
      </ModalDialog>
    </Modal>
  );
};

export default ImagePreview;
